export const SIGNOUT_MESSAGE_TYPE = 'SIGNOUT';
export const SIGNIN_MESSAGE_TYPE = 'SIGNIN';
